import React from 'react';
import { Img } from 'react-image'
import LogoImage from '../assets/img/SimplifiedHRLogo.png';
import E3LogoImage from '../assets/img/EncompassLogo.png';

const Header = ({singleSurvey}) => {

        return (
            <div className='container-fluid p-0 m-0'>
                <div className='logo-image pt-5 pb-5 text-center'>
                    {singleSurvey === false ? <Img className='logo-img' src={LogoImage} /> : <Img className='logo-img' src={E3LogoImage} width="350px" />}
                </div>
            </div>
        );    
}

export default Header;